import { useState } from "react";
import { useRequest, useInterval } from "ahooks";
import { Card } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { message as messageService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function MessageCard({ label, title, url }) {
  const [version, setVersion] = useState(Date.now());
  const auth = useAuthContext();
  useInterval(() => {
    setVersion(Date.now());
  }, 30000);
  const { data = { total: 0, results: [] } } = useRequest(
    () => {
      return messageService.listMyReceiveMessage(
        { department_type_name: title, page: 1, page_size: 10 },
        auth.token
      );
    },
    {
      ready: !!auth?.token,
      refreshDeps: [version, auth?.token],
    }
  );

  const items = data.results.map((i) => (
    <li key={`anno-${i.id}`} className="message-item">
      <div className="message-dot"> · </div>
      <div className="message-label">
        <Link to={`/workshop/mrece/detail/${i.id}`}>
          &lt; <span>{i.sender.name}</span> &gt;
          {i.title}
        </Link>
      </div>
      <div className="message-date">{moment(i.published_at).format("M-D")}</div>
    </li>
  ));
  return (
    <Card
      title={label || title}
      size="small"
      headStyle={{
        backgroundColor: "#1e87fb",
        color: "#fff",
        fontFamily: "Microsoft YaHei-Bold",
        fontWeight: "bold",
        fontSize: 18,
      }}
      bodyStyle={{ padding: 0 }}
      extra={
        <Link to={url} className="ant-btn ant-btn-primary">
          查看更多
        </Link>
      }
    >
      <ul className="message-list">{items}</ul>
    </Card>
  );
}

export default MessageCard;
